(function(){
  function idx(track){return Math.round(track.scrollLeft/Math.max(track.clientWidth,1));}
  function sync(car){
    var track=car.querySelector('.wf-car__track'); if(!track) return;
    var i=idx(track), n=track.children.length;
    car.querySelectorAll('.wf-car__dots span').forEach(function(d,k){d.classList.toggle('on',k===i);});
    var c=car.querySelector('.wf-car__count'); if(c){c.textContent=(i+1)+' / '+n;}
    var g=car.closest('[data-wf-gallery]');
    if(g){
      var ths=g.querySelectorAll('[data-wf-thumb]');
      ths.forEach(function(t,k){t.classList.toggle('on',k===i);});
      var th=ths[i]; if(th){var box=th.parentElement;box.scrollTo({left:th.offsetLeft-box.clientWidth/2+th.clientWidth/2,behavior:'smooth'});}
    }
  }
  function go(car,n){
    var track=car.querySelector('.wf-car__track'); var total=track.children.length;
    n=(n+total)%total;
    for(var k=Math.max(0,n-1);k<=Math.min(total-1,n+1);k++){track.children[k].loading='eager';}
    var far=Math.abs(n-idx(track))>3;
    track.scrollTo({left:n*track.clientWidth,behavior:far?'auto':'smooth'});
  }
  function openZoom(src){
    var o=document.createElement('div'); o.className='wf-zoomov';
    o.innerHTML='<img alt=""><button type="button" aria-label="Close">&times;</button>';
    o.querySelector('img').src=src;
    o.addEventListener('click',function(){o.remove();});
    document.addEventListener('keydown',function esc(e){if(e.key==='Escape'){o.remove();document.removeEventListener('keydown',esc);}});
    document.body.appendChild(o);
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-wf-arrow]');
    if(a){e.preventDefault();e.stopPropagation();var car=a.closest('.wf-car');var t=car.querySelector('.wf-car__track');go(car,idx(t)+(a.dataset.wfArrow==='next'?1:-1));return;}
    var th=e.target.closest('[data-wf-thumb]');
    if(th){var g=th.closest('[data-wf-gallery]');go(g.querySelector('.wf-car'),parseInt(th.dataset.wfThumb,10));return;}
    var z=e.target.closest('[data-wf-zoom]');
    if(z){var car2=z.closest('[data-wf-gallery]').querySelector('.wf-car');var t2=car2.querySelector('.wf-car__track');var im=t2.children[idx(t2)];if(im){openZoom(im.currentSrc||im.src);}return;}
    var q=e.target.closest('[data-wf-qty]');
    if(q){var inp=q.parentElement.querySelector('input');var v=Math.max(1,(parseInt(inp.value,10)||1)+parseInt(q.dataset.wfQty,10));inp.value=v;return;}
    var sg=e.target.closest('[data-wf-sizeguide]');
    if(sg){var d=document.getElementById('wf-fit');if(d){d.open=true;}}
  });
  document.addEventListener('scroll',function(e){
    if(e.target&&e.target.classList&&e.target.classList.contains('wf-car__track')){sync(e.target.closest('.wf-car'));}
  },true);

  /* Card image motion across ALL images: hover-scrub on desktop, scroll-linked on touch */
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  function loadAll(car){
    if(car.dataset.wfLoaded) return; car.dataset.wfLoaded='1';
    car.querySelectorAll('img').forEach(function(im){im.loading='eager';});
  }
  function setIdx(car,i,smooth){
    var track=car.querySelector('.wf-car__track'); if(!track) return;
    var n=track.children.length; i=Math.max(0,Math.min(n-1,i));
    if(idx(track)===i) return;
    track.scrollTo({left:i*track.clientWidth,behavior:smooth?'smooth':'auto'});
  }
  var cards=[].slice.call(document.querySelectorAll('.wf-card__wrap .wf-car'));
  if(cards.length&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){var ims=en.target.querySelectorAll('img');for(var k=0;k<Math.min(4,ims.length);k++){ims[k].loading='eager';}io.unobserve(en.target);}});},{rootMargin:'300px'});
    cards.forEach(function(c){io.observe(c);});
  }
  if(fine&&!reduce){
    cards.forEach(function(car){
      var track=car.querySelector('.wf-car__track'); var n=track.children.length; if(n<2) return;
      car.addEventListener('mouseenter',function(){loadAll(car);});
      car.addEventListener('mousemove',function(e){var r=car.getBoundingClientRect();setIdx(car,Math.floor((e.clientX-r.left)/r.width*n),false);});
      car.addEventListener('mouseleave',function(){setIdx(car,0,true);});
    });
  }
  if(!fine&&!reduce){
    var touched=new WeakMap();
    cards.forEach(function(car){var t=car.querySelector('.wf-car__track');t.addEventListener('touchstart',function(){touched.set(car,Date.now());loadAll(car);},{passive:true});});
    var ticking=false;
    var onScroll=function(){
      if(ticking) return; ticking=true;
      requestAnimationFrame(function(){
        ticking=false; var vh=window.innerHeight;
        cards.forEach(function(car){
          var r=car.getBoundingClientRect(); if(r.bottom<0||r.top>vh) return;
          var t=car.querySelector('.wf-car__track'); var n=t.children.length; if(n<2) return;
          if(Date.now()-(touched.get(car)||0)<2500) return;
          var p=(vh-r.top)/(vh+r.height); if(p>0.25&&p<0.75){loadAll(car);}
          var qv=Math.min(0.999,Math.max(0,(p-0.3)/0.4));
          setIdx(car,Math.floor(qv*n),true);
        });
      });
    };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  function initProduct(form){
    var data=JSON.parse(form.querySelector('[data-wf-variants]').textContent);
    var idInput=form.querySelector('[name=id]');
    var btns=document.querySelectorAll('[data-wf-add]');
    var prices=document.querySelectorAll('[data-wf-price]');
    var cmp=document.querySelector('[data-wf-compare]');
    var sv=document.querySelector('[data-wf-save]');
    var stock=document.querySelector('[data-wf-stock]');
    var gal=document.querySelector('[data-wf-gallery] .wf-car');
    function update(e){
      var chosen=[];form.querySelectorAll('.wf-opt[data-wf-option]').forEach(function(g){var c=g.querySelector('input:checked');chosen[parseInt(g.dataset.wfOption,10)]=c?c.value:null;});
      var v=data.find(function(x){return x.options.every(function(o,i){return o===chosen[i];});});
      if(v){
        idInput.value=v.id;
        btns.forEach(function(b){b.disabled=!v.available;b.firstElementChild.textContent=v.available?('ADD TO BAG \u2014 '+v.price):'SOLD OUT';});
        prices.forEach(function(p){p.textContent=v.price;});
        if(cmp){cmp.textContent=v.compare||'';cmp.hidden=!v.compare;}
        if(sv){sv.textContent=v.save?('SAVE '+v.save):'';sv.hidden=!v.save;}
        if(stock){stock.textContent=v.available?'In stock \u2014 printed to order':'Sold out';stock.classList.toggle('out',!v.available);}
        try{var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}catch(err){}
        if(e&&e.target&&gal&&v.img>=0){var og=e.target.closest('.wf-opt');if(og&&og.dataset.wfName==='color'){go(gal,v.img);}}
      } else {
        btns.forEach(function(b){b.disabled=true;b.firstElementChild.textContent='UNAVAILABLE';});
      }
    }
    form.addEventListener('change',update);update();
  }
  document.querySelectorAll('[data-wf-form]').forEach(function(f){try{initProduct(f);}catch(err){}});
  var sortSel=document.querySelector('[data-wf-sort]');
  if(sortSel){sortSel.addEventListener('change',function(){var u=new URL(window.location.href);u.searchParams.set('sort_by',sortSel.value);window.location.href=u.toString();});}
})();
